import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { McdFinDashboard } from '@/sc/entities/mcdInv/dashboard/fin/McdFinDashboard';
import { McdInvDashboard } from '@/sc/entities/mcdInv/dashboard/inv/McdInvDashboard';
import { TrxViewer } from '@/sc/entities/trx/TrxViewer';
import { Route } from 'react-router-dom';
import { ChbkDashboard } from './entities/indirSale/dashboard/ChbkDashboard';
import { McdBoard } from './entities/mcdBoard/McdBoard';
import { McdDispCLDList } from './entities/mcdUtilLine/McdDispCLDList';
import { McoFinDashboard } from './entities/mcoInv/dashboard/fin/McoFinDashboard';
import { McoInvDashboard } from './entities/mcoInv/dashboard/inv/McoInvDashboard';
import { FeesForecastPerspective } from './org/ucb/entities/dsaForecast/FeesForecastPerspective';

const scRoutes = [
  <Route path="/sc/dir-sale" element={<EntityView />} />,
  <Route path="/sc/dir-sale-line" element={<EntityView />} />,
  <Route path="/sc/indir-sale" element={<EntityView />} />,
  <Route path="/sc/indir-sale-line" element={<EntityView />} />,
  <Route path="/sc/chbk-claim" element={<EntityView />} />,
  <Route path="/sc/chbk-claim-line" element={<EntityView />} />,
  <Route path="/sc/chbk-dashboard" element={< ChbkDashboard />} />,
  <Route path="/sc/mcd-util" element={<EntityView />} />,
  <Route path="/sc/mcd-util-line" element={<EntityView />} />,
  <Route path="/sc/mcd-disp-cld" element={<McdDispCLDList />} />,
  <Route path="/sc/mcd-claim" element={<EntityView />} />,
  <Route path="/sc/mcd-claim-line" element={<EntityView />} />,
  <Route path="/sc/mcd-disp" element={<EntityView />} />,
  <Route path="/sc/mcd-board" element={<McdBoard />} />,
  <Route path="/sc/pymt/:claimType" element={<EntityView />} />,
  <Route path="/sc/pymt" element={<EntityView />} />,
  <Route path="/sc/mcd-dashboard" element={< McdInvDashboard />} />,
  <Route path="/sc/mcd-fin-dashboard" element={< McdFinDashboard />} />,
  <Route path="/sc/mcd-inv" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-claim-pymt" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-date-tracker" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-line" element={<EntityView />} />,
  <Route path="/sc/channel-data" element={<EntityView />} />,
  <Route path="/sc/adj" element={<EntityView />} />,
  <Route path="/sc/mco-inv" element={<EntityView />} />,
  <Route path="/sc/mco-inv-line" element={<EntityView />} />,
  <Route path="/sc/mco-claim" element={<EntityView />} />,
  <Route path="/sc/mco-claim-line" element={<EntityView />} />,
  <Route path="/sc/mco-dashboard" element={< McoInvDashboard />} />,
  <Route path="/sc/mco-fin-dashboard" element={< McoFinDashboard />} />,
  <Route path="/sc/trx-viewer/:trxSrcCode" element={<TrxViewer />}/>,
  <Route path="/sc/inctv-inv" element={<EntityView />} />,
  <Route path="/sc/inctv-claim" element={<EntityView />} />,
  <Route path="/sc/inctv-claim-line" element={<EntityView />} />,
  <Route path="/sc/acct-bal" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-src" element={<EntityView />} />,
  <Route path="/sc/channel-data" element={<EntityView />} />,
  <Route path="/sc/mcd-pymt-master" element={<EntityView />} />,
  <Route path="/sc/fees-forecast" element={<EntityView  perspectiveComponent={FeesForecastPerspective}/>} />
]

export default scRoutes;